// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"aae12f00","290":"19fee981","400":"2b42166b","716":"f55578ba"}[chunkId] + ".chunk.js";
};